import clsx from "clsx";
import React from "react";
import { ControllerFieldState } from "react-hook-form";
import AddressAutocomplete from "components/Tiles/commonComponents/AddressAutocomplete";
import { FormControl, FormItem } from "components/ui/form";
import { APP_LANGUAGES } from "utils/language";

type AddressAutocompleteInputProps = {
  mRef?: React.RefObject<HTMLInputElement>;
  field: any;
  fieldState: ControllerFieldState;
  className?: string;
  language?: APP_LANGUAGES;
};

const AddressAutocompleteInput = ({ field, fieldState, className, language }: AddressAutocompleteInputProps) => {
  return (
    <FormItem className={clsx("relative", className)}>
      <FormControl>
        <AddressAutocomplete
          language={language}
          hasError={!!fieldState.error}
          address={field.value}
          updateAddress={(newAddress) => field.onChange(newAddress)}
        />
      </FormControl>
    </FormItem>
  );
};

export default AddressAutocompleteInput;
